import { EFinancingProgram } from '@if/core/types'
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import useFeatureFlags from '@src/data/api/featureSwitch-api/featureSwitch-api'
import { RateAgreement } from '@src/data/types/Merchant'
import { useTranslation } from 'react-i18next'

interface Props {
  financingProgramId: EFinancingProgram
  rateAgreements: RateAgreement[]
}

const RateAgreementsTable = ({ financingProgramId, rateAgreements }: Props) => {
  const { t } = useTranslation()
  const [featureFlags] = useFeatureFlags()
  const useRateAgreementWithFees = featureFlags?.useRateAgreementWithFees ?? false

  return (
    <Grid container size={{ sm: 12, md: useRateAgreementWithFees ? 6 : 3 }} marginBottom={2}>
      <Grid container size={12} textAlign={'center'} marginBottom={1}>
        <Typography component="div">{t(`EFinancingProgram.${financingProgramId}`, { ns: 'enum' })}</Typography>
      </Grid>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="right">Min Ers</TableCell>
              <TableCell align="right">{t('merchant.promo.interestRate')}</TableCell>
              {useRateAgreementWithFees && <TableCell align="right">{t('merchant.ratesAndFees.adminFeeCustomer')}</TableCell>}
              {useRateAgreementWithFees && <TableCell align="right">{t('merchant.ratesAndFees.adminFeeMerchant')}</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {rateAgreements.map((rateAgreement) => (
              <TableRow key={rateAgreement.minErs} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row" align="right">
                  {rateAgreement.minErs}
                </TableCell>
                <TableCell align="right">{rateAgreement.rate}</TableCell>
                {useRateAgreementWithFees && <TableCell align="right">{rateAgreement.lenderFeeRate}</TableCell>}
                {useRateAgreementWithFees && <TableCell align="right">{rateAgreement.adminFeeMerchant}</TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  )
}

export default RateAgreementsTable
